import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { tap } from 'rxjs';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { ResultConfirmationRenvoiComponent } from './result-confirmation-renvoi/result-confirmation-renvoi.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-confirmation-reenvoi-invitation-dialog',
    templateUrl: './confirmation-reenvoi-invitation-dialog.component.html',
    styleUrls: ['./confirmation-reenvoi-invitation-dialog.component.scss'],
    imports: [
        MatDialogModule, TranslateModule
    ]
})
export class ConfirmationReenvoiInvitationDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmationReenvoiInvitationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { userIds: number[] },
    private utilisateurService: UtilisateurService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  onConfirm(): void {
    this.utilisateurService.renvoyerInvitationsUtilisateurs(this.data.userIds).pipe(
      tap(
        () => {
          this.dialogRef.close(true);
          this.dialog.open(ResultConfirmationRenvoiComponent, {
            width: '400px'
          });
        },
      )
    ).subscribe();
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
